export const CommentTypes = {
  LOAD: 'LOAD',
  VERIFICATION: 'VERIFICATION',
  REVISION: 'REVISION',
};